import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';
import isString from 'lodash/isString';

export function applyQuizFormDefaults({ common, whenCompany, whenSolo }, form = {}) {
  const { clientType } = form;

  const dictionary = merge(
    {},
    common,
    clientType === 'company' ? whenCompany : whenSolo,
    cleanupEmptyStringsFromObjectValues(form),
  );

  return dictionary;
}

function cleanupEmptyStringsFromObjectValues(obj) {
  return pickBy(obj, value => {
    if (!isString(value)) {
      return value;
    }

    return value.trim();
  });
}
